import script from "./ChartCustome.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChartCustome.vue?vue&type=script&setup=true&lang=ts"

import "./ChartCustome.vue?vue&type=style&index=0&id=5b055e2c&lang=css"

const __exports__ = script;

export default __exports__